import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import { SiteImagesProvider } from "./context/SiteImagesContext";
import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import WhatIsGR from "./pages/WhatIsGR";
import OurClub from "./pages/OurClub";
import Inscriptions from "./pages/Inscriptions";
import Results from "./pages/Results";
import Actualites from "./pages/Actualites";
import Boutique from "./pages/Boutique";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProtectedRoute from "./pages/admin/ProtectedRoute";

const PublicLayout = ({ children }) => (
  <SiteConfigProvider>
    <SiteImagesProvider>
      <SmoothScroll>
        <Header />
        <main>{children}</main>
        <Footer />
      </SmoothScroll>
    </SiteImagesProvider>
  </SiteConfigProvider>
);

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      </Routes>
    );
  }

  return (
    <PublicLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quest-ce-que-la-gr" element={<WhatIsGR />} />
        <Route path="/notre-club" element={<OurClub />} />
        <Route path="/inscriptions" element={<Inscriptions />} />
        <Route path="/resultats" element={<Results />} />
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/boutique" element={<Boutique />} />
      </Routes>
    </PublicLayout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="bottom-right" theme="dark" richColors />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
